import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import axios from 'axios';
import Turnos from './pages/Turnos';
import Pacientes from './pages/Pacientes';
import Historial from './pages/Historial';
import Calendario from './pages/Calendario';
import Medicos from './pages/Medicos';
import Especialidades from './pages/Especialidades';
import Staff from './pages/Staff';
import Login from './pages/Login';
import MisDatos from './pages/MisDatos';
import PanelPaciente from './pages/PanelPaciente';
import Configuracion from './pages/Configuracion';
import BusquedaHC from './pages/BusquedaHC';
import Consulta from './pages/Consulta';
import ObrasSociales from './pages/ObrasSociales';
import Layout from './components/Layout';

const API = process.env.REACT_APP_API_URL || '';

const TEMA_DEFECTO = {
  color_fondo:      '#1a1a2e',
  color_superficie: '#16213e',
  color_primario:   '#0f3460',
  color_acento:     '#90caf9',
};

function aplicarTema(tema) {
  const root = document.documentElement;
  root.style.setProperty('--c-fondo',      tema.color_fondo      || TEMA_DEFECTO.color_fondo);
  root.style.setProperty('--c-superficie', tema.color_superficie || TEMA_DEFECTO.color_superficie);
  root.style.setProperty('--c-primario',   tema.color_primario   || TEMA_DEFECTO.color_primario);
  root.style.setProperty('--c-acento',     tema.color_acento     || TEMA_DEFECTO.color_acento);
}

function RutaProtegida({ usuario, rolesPermitidos, children }) {
  if (!usuario) return <Navigate to="/login" replace />;
  if (rolesPermitidos && !rolesPermitidos.includes(usuario.rol)) {
    return <Navigate to="/sin-acceso" replace />;
  }
  return children;
}

function rutaInicio(usuario) {
  if (!usuario) return '/login';
  if (usuario.rol === 'paciente') {
    return usuario.datos_confirmados ? '/panel-paciente' : '/mis-datos';
  }
  return '/calendario';
}

function App() {
  const [usuario, setUsuario] = useState(null);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    // Cargar tema de colores al arrancar
    axios.get(`${API}/api/configuracion/tema`)
      .then(r => aplicarTema(r.data))
      .catch(() => aplicarTema(TEMA_DEFECTO));

    const token = localStorage.getItem('token');
    const rol = localStorage.getItem('rol');
    const nombre = localStorage.getItem('nombre');
    const expira = localStorage.getItem('expira');
    const datos_confirmados = localStorage.getItem('datos_confirmados') === '1';

    if (token && rol && nombre && expira) {
      if (Date.now() < parseInt(expira)) {
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        setUsuario({ token, rol, nombre, datos_confirmados });
      } else {
        localStorage.clear();
      }
    }
    setCargando(false);
  }, []);

  function handleLogin(data) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${data.token}`;
    setUsuario({
      token: data.token,
      rol: data.rol,
      nombre: data.nombre,
      datos_confirmados: !!data.datos_confirmados,
    });
  }

  function handleLogout() {
    delete axios.defaults.headers.common['Authorization'];
    localStorage.clear();
    setUsuario(null);
  }

  function handleDatosConfirmados() {
    localStorage.setItem('datos_confirmados', '1');
    setUsuario(prev => ({ ...prev, datos_confirmados: true }));
  }

  if (cargando) return null;

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={
          usuario ? <Navigate to={rutaInicio(usuario)} replace /> : <Login onLogin={handleLogin} />
        } />
        <Route path="/sin-acceso" element={
          <div style={{ padding: 40, color: '#fff' }}>No tenés acceso a esta sección.</div>
        } />
        <Route path="/*" element={
          <RutaProtegida usuario={usuario}>
            <Layout usuario={usuario} onLogout={handleLogout}>
              <Routes>
                <Route path="/" element={<Navigate to={rutaInicio(usuario)} replace />} />

                {/* Rutas del paciente */}
                <Route path="/mis-datos" element={
                  <RutaProtegida usuario={usuario} rolesPermitidos={['paciente']}>
                    <MisDatos usuario={usuario} onConfirmado={handleDatosConfirmados} />
                  </RutaProtegida>
                } />
                <Route path="/panel-paciente" element={
                  <RutaProtegida usuario={usuario} rolesPermitidos={['paciente']}>
                    <PanelPaciente usuario={usuario} />
                  </RutaProtegida>
                } />

                {/* Rutas del staff */}
                <Route path="/calendario" element={
                  <RutaProtegida usuario={usuario} rolesPermitidos={['admin', 'recepcionista', 'medico']}>
                    <Calendario />
                  </RutaProtegida>
                } />
                <Route path="/turnos" element={
                  <RutaProtegida usuario={usuario} rolesPermitidos={['admin', 'recepcionista', 'medico']}>
                    <Turnos />
                  </RutaProtegida>
                } />
                <Route path="/pacientes" element={
                  <RutaProtegida usuario={usuario} rolesPermitidos={['admin', 'recepcionista']}>
                    <Pacientes />
                  </RutaProtegida>
                } />
                <Route path="/historial/:id" element={
                  <RutaProtegida usuario={usuario} rolesPermitidos={['admin', 'medico']}>
                    <Historial />
                  </RutaProtegida>
                } />
                <Route path="/consulta/:turnoId" element={
                  <RutaProtegida usuario={usuario} rolesPermitidos={['admin', 'medico']}>
                    <Consulta />
                  </RutaProtegida>
                } />
<Route path="/busqueda-hc" element={
                  <RutaProtegida usuario={usuario} rolesPermitidos={['admin', 'medico']}>
                    <BusquedaHC />
                  </RutaProtegida>
                } />
                <Route path="/medicos" element={
                  <RutaProtegida usuario={usuario} rolesPermitidos={['admin']}>
                    <Medicos />
                  </RutaProtegida>
                } />
                <Route path="/especialidades" element={
                  <RutaProtegida usuario={usuario} rolesPermitidos={['admin']}>
                    <Especialidades />
                  </RutaProtegida>
                } />
                <Route path="/obras-sociales" element={
                  <RutaProtegida usuario={usuario} rolesPermitidos={['admin']}>
                    <ObrasSociales />
                  </RutaProtegida>
                } />
                <Route path="/staff" element={
                  <RutaProtegida usuario={usuario} rolesPermitidos={['admin']}>
                    <Staff />
                  </RutaProtegida>
                } />
                <Route path="/configuracion" element={
                  <RutaProtegida usuario={usuario} rolesPermitidos={['admin']}>
                    <Configuracion onTemaActualizado={aplicarTema} />
                  </RutaProtegida>
                } />
              </Routes>
            </Layout>
          </RutaProtegida>
        } />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
